import styled from 'styled-components';
import { Box, Gap, theme } from '@salecycle/ui-component-library';
import { useTemplateEditorState } from 'sections/design/template-management/sections/template-editor/context/UseTemplateEditorContext';

const ValidationCounter = styled.div<Props>`
  background-color: ${props => props.color};
  height: 35px;
  min-width: 35px;
  padding: 5px;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.vars.newColor.white};
  justify-content: center;
`;

interface Props {
  color: string;
}

export const ValidationCounters = () => {
  const { validationCounts } = useTemplateEditorState();
  return (
    <Box>
      <ValidationCounter data-testid="ValidationFailCount" color={theme.vars.newColor.red2}>
        {validationCounts.fail}
      </ValidationCounter>
      <Gap right={10} />
      <ValidationCounter data-testid="ValidationWarningCount" color={theme.vars.newColor.orange2}>
        {validationCounts.warning}
      </ValidationCounter>
      <Gap right={10} />
      <ValidationCounter data-testid="ValidationPassCount" color={theme.vars.newColor.green2}>
        {validationCounts.pass}
      </ValidationCounter>
    </Box>
  );
};
